const pairs = [
    ['M', 1000],
    ['D', 500],
    ['C', 100],
    ['L', 50],
    ['X', 10],
    ['V', 5]
] as const;
  
export const toRomanNumerals = (num: number) => {
  for (const [ char, limit ] of pairs) {
    if (num >= limit) {
      return `${char}${toRomanNumerals(num - limit)}`;
    }
  
    if (num == limit - 1) {
      return `I${char}`;
    }
  }
  
  return 'I'.repeat(num);
};
  